import { render, staticRenderFns } from "./simControls.vue?vue&type=template&id=4af08664&scoped=true&"
import script from "./simControls.vue?vue&type=script&lang=js&"
export * from "./simControls.vue?vue&type=script&lang=js&"
import style0 from "./simControls.vue?vue&type=style&index=0&id=4af08664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af08664",
  null
  
)

export default component.exports